import { render, staticRenderFns } from "./teach.vue?vue&type=template&id=b7b3caac&scoped=true"
import script from "./teach.vue?vue&type=script&lang=js"
export * from "./teach.vue?vue&type=script&lang=js"
import style0 from "./teach.vue?vue&type=style&index=0&id=b7b3caac&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b3caac",
  null
  
)

export default component.exports